import { Page, PageProps } from './Page';
import { ViewTabs } from '../ViewTabs';
import {
  MARQTING_CUSTOMER_CASES_ROUTE,
  MARQTING_FUNCTIONALITIES_ROUTE,
  MARQTING_PRICING_ROUTE,
  MARQTING_ROUTE,
} from '../../pages/routes';
import FlagIcon from '@mui/icons-material/Flag';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import EuroIcon from '@mui/icons-material/Euro';
import React from 'react';
import Image from 'next/image';
import { useWindowDimensions } from '../../hooks';
import { MarqtingDarkTheme } from '../../themes/marqting-dark.theme';
import { Box } from '@mui/material';

interface MarqtingPageProps extends PageProps {
  selectedTab: number;
}

export function MarqtingPage({
  children,
  selectedTab,
  ...props
}: MarqtingPageProps) {
  const { isMobile } = useWindowDimensions();

  return (
    <Page
      {...props}
      theme={MarqtingDarkTheme}
      backgroundColor={'secondary.main'}
      cookiesProps={{ isAppPage: true }}
    >
      <ViewTabs
        fixed
        page
        selected={selectedTab}
        tabs={[
          {
            label: 'Start',
            slug: MARQTING_ROUTE,
            icon: <FlagIcon />,
            component: children,
          },
          {
            label: 'Functionaliteiten',
            slug: MARQTING_FUNCTIONALITIES_ROUTE,
            icon: <FactCheckIcon />,
            component: children,
          },
          {
            label: 'Klantcases',
            slug: MARQTING_CUSTOMER_CASES_ROUTE,
            icon: <SwitchAccountIcon />,
            component: children,
          },
          {
            label: 'Prijzen',
            slug: MARQTING_PRICING_ROUTE,
            icon: <EuroIcon />,
            component: children,
          },
        ]}
        logo={
          isMobile ? (
            <Box
              sx={{
                maxHeight: 50,
                display: 'flex',
                alignItems: 'center',
                pt: 0.5,
              }}
            >
              <Image
                width={40}
                height={50}
                src={
                  'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/marqting_beeldmerk_white.svg'
                }
                alt={'MarQting Logo'}
              />
            </Box>
          ) : (
            <Image
              width={130}
              height={20}
              src={
                'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/marqting_logo_white.svg'
              }
              alt={'MarQting Logo'}
            />
          )
        }
      />
    </Page>
  );
}
